export default __webpack_public_path__ + "static/media/logo.c2ced713.png";